import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var CamelizePipe = (function () {
    function CamelizePipe() {
    }
    CamelizePipe.prototype.transform = function (text, chars) {
        if (chars === void 0) { chars = '\\s'; }
        if (!isString(text)) {
            return text;
        }
        return text.toLowerCase()
            .split(/[-_\s]/g)
            .filter(function (v) { return !!v; }).map(function (word, key) {
            return !key ? word : (word.slice(0, 1).toUpperCase() + word.slice(1));
        }).join('');
    };
    CamelizePipe.decorators = [
        { type: Pipe, args: [{ name: 'camelize' },] },
    ];
    /** @nocollapse */
    CamelizePipe.ctorParameters = function () { return []; };
    return CamelizePipe;
}());
export { CamelizePipe };
//# sourceMappingURL=camelize.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/camelize.js
// module id = 277
// module chunks = 4